"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSocialNetworkTemplate = exports.getSocialNetworkItem = exports.getUsernameFromText = exports.getSocialNetworkType = void 0;
const utils_1 = require("../clipboard/utils");
const types_1 = require("@smartsuite/types");
const getSocialNetworkType = (value) => {
    const facebookRegExp = new RegExp(types_1.socialNetworkInputProperties.facebook.regexp, "i");
    const instagramRegExp = new RegExp(types_1.socialNetworkInputProperties.instagram.regexp, "i");
    const twitterRegExp = new RegExp(types_1.socialNetworkInputProperties.twitter.regexp, "i");
    const linkedinRegExp = new RegExp(types_1.socialNetworkInputProperties.linkedin.regexp, "i");
    if (facebookRegExp.test(value))
        return "facebook";
    if (instagramRegExp.test(value))
        return "instagram";
    if (twitterRegExp.test(value))
        return "twitter";
    if (linkedinRegExp.test(value))
        return "linkedin";
    return null;
};
exports.getSocialNetworkType = getSocialNetworkType;
const getUsernameFromText = (socialNetwork, text) => {
    const regExp = new RegExp(types_1.socialNetworkInputProperties[socialNetwork].regexp, "i");
    const match = regExp.exec(text);
    if (match) {
        for (let i = 1; i <= match.length - 1; i++) {
            if (match[i]) {
                return match[i];
            }
        }
    }
    return "";
};
exports.getUsernameFromText = getUsernameFromText;
const getSocialNetworkItem = (text, choices) => {
    const socialNetwork = (0, exports.getSocialNetworkType)(text);
    if (!socialNetwork) {
        return null;
    }
    const enabled = (0, utils_1.findChoiceValuesByLabels)(choices, [socialNetwork]);
    // check if we can find anything enabled in field params
    if (!enabled.length) {
        return null;
    }
    const username = (0, exports.getUsernameFromText)(socialNetwork, text);
    if (!username) {
        return null;
    }
    return { [`${socialNetwork}_username`]: username };
};
exports.getSocialNetworkItem = getSocialNetworkItem;
const getSocialNetworkTemplate = () => {
    return {
        facebook_username: "",
        instagram_username: "",
        twitter_username: "",
        linkedin_username: "",
        sys_root: "",
    };
};
exports.getSocialNetworkTemplate = getSocialNetworkTemplate;
